import styled, { css } from 'styled-components';

// nav on Mobile
export const MobileNav = styled.nav`
  display: none;
  position: fixed;
  z-index: 200;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 60px;
  box-shadow: 0 -3px 16px 0 #d7dae366;
  background-color: #000;
  justify-content: space-between;

  .nav-item {
    touch-action: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 10px;
    color: #fff;
    position: relative;
    h4 {
      font-size: 8px;
      font-weight: 400;
      text-transform: capitalize;
      line-height: 1;
    }
    svg {
      height: auto;
      margin-bottom: 10px;
      max-width: 17px;
      max-height: 17px;
      display: block;
    }

    &.wishlist svg {
      width: 16px;
    }

    &.active svg {
      color: #9dc669;
      font-weight: 500;
    }
    &.active::after {
      opacity: 1;
    }
  }

  @media screen and (max-width: 960px) {
    display: flex;
  }
`;

export const StyledHeader = styled.header<any>`
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;
    background-color: #1F1F1F;
    padding: 24px 0;
    box-shadow: 0px 4px 17px rgb(0 0 0 / 25%);
    @media screen and (max-width: 1550px) {
        padding: 20px 0;
    }
    @media screen and (max-width: 740px) {
        padding: 8px 0;
        box-shadow: 0px 3px 8px rgb(0 0 0 / 25%);

    }
`;
export const HeaderMain = styled.div<any>`
    display: flex;
    align-items: center;
    height: 56px;
    position: relative;
    .brand-link {
        background-color: var(--primary);
        height: 100%;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        svg {
            height: 30px;
            &:last-of-type {
                display: none;
            }
        }
    }
    .chat-btn {
        display: none;
    }
    > *:not(:last-child) {
        margin-right: 16px !important;
    }
    @media screen and (max-width: 960px) {
        > *:not(:last-child) {
            margin-right: unset !important;
        }
        .chat-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
            border-radius: 8px;
            background-color: #fff;
            margin-left:12px;
        }
        .brand-link {
            margin-right: 12px !important;
        }
    }
    @media screen and (max-width: 740px) {
        height: 48px;
        .chat-btn {
            margin-left:8px;
        }
        .brand-link {
            margin-right: 8px !important;
            padding: 0;
            width: 48px;
            svg {
                height: 26px;
                display: none;
                &:last-of-type {
                    display: block;
                }
            }
        }
    }
`;
export const CategoryBtn = styled.button<any>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-radius: 8px;
    background-color: #fff;
    color: #000;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 700;
    svg {
        height: 13px;
        margin-right: 12px;
    }
    @media screen and (max-width:960px) {
        display: none;
    }
`;

export const SearchForm = styled.form<any>`
    background-color: #474747;
    flex: 1;
    display: flex;
    align-items: center;
    border-radius: 8px;
    height: 100%;
    button {
        margin: 0 12px;
        color: #fff;
    }
    input {
        flex: 1;
        margin-right: 12px;
        line-height: 100%;
        font-size: 12px;
        border: none;
        color: #fff;
        background-color: transparent;
        &::placeholder {
            color: inherit;
        }
    }
    @media screen and (max-width: 740px) {
        background-color: #fff;
        button {
            color: #000;
            margin: 0 8px 0 12px;
        }
        input {
            color: #000;
        }
    }
`;
export const FilterDropdown = styled.div<any>`
    position: relative;
    height: 100%;

    .label {
        height: 100%;
        background-color: var(--primary);
        min-width: 152px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: bold;
        span {
            margin: 0 8px;
        }
        > svg:first-of-type {
            width: 20px;
        }
    }
    .options {
        opacity: 0;
        visibility: hidden;
        transition: all 0.2s ease 0s;
        position: absolute;
        z-index: 100;
        top: calc(100% + 24px);
        left: 0;
        width: 100%;
        background-color: #fff;
        border-radius: 8px;
        padding: 16px;
        box-shadow: 0 0 4px rgba(0,0,0, 0.25);
        ::before {
            content: "";
            position: absolute;
            top: -7px;
            right: 13px;
            border-bottom: 7px solid #fff;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
        }
        button {
            display: block;
            width: 100%;
            text-align: left;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.7;
            :first-of-type {
                pointer-events: none;
            }
            :not(:last-of-type) {
                margin-bottom: 16px;
            }
            &.active {
                color: var(--primary-dark);
            }
        }
    }
    ${({open})=> open && css`
        .options {
            opacity: 1;
            visibility: visible;
            transition: all 0.6s ease 0s;
        }   
    `}
    @media screen and (max-width:960px) {
        .label {
            display: none;
        }
       .options {
            border-radius: 0;
            transition: none;
            position: fixed;
            top: 96px;
            left: 0;
            width: 100%;
            height: 100%;
            ::before {display:none;}
            button {
                &.active {
                    color: var(--primary-dark);
                }
            }
       }
    }
    @media screen and (max-width:740px) {
        .options {
            top: 64px;
        }
    }
`;

export const AuthBtns = styled.div<any>`
    position: relative;
    height: 100%;

    .btn {
        min-width: 116px;
        min-width: 135px;
        background-color: #474747;
        color: #fff;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 700;
        svg {
            margin-right: 12px;
        }
    }
    .dropdown {
        position: absolute;
        top: calc(100% + 24px);
        right: 0;
        background: rgb(255, 255, 255);
        border-radius: 16px;
        width: 420px;
        padding: 20px;
        opacity: 0;
        visibility: hidden;
        transition: all 0.2s ease 0s;
        z-index: 100;
        ::after {
            content: "";
            position: absolute;
            top: -7px;
            right: 32px;
            border-bottom: 7px solid #fff;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
        }
        &.open {
            opacity: 1;
            visibility: visible;
            transition: all 0.6s ease 0s;
        }
        .header {
            display: flex;
            align-items: center;
            padding-bottom: 20px;
            .headline {
                font-size: 24px;
                font-weight: 700;
            }
            button {
                margin-left: auto;
                display: flex;
                -webkit-box-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                align-items: center;
                height: 36px;
                padding: 0px 12px;
                border-radius: 20px;
                background-color: var(--primary-light);
                font-size: 14px;
                font-weight: 500;
                svg {
                    margin-right: 5px;
                }
            }
        }
        .nav {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            padding: 16px 0;
            border-top: 1px solid #F4F5F6;
            border-bottom: 1px solid #F4F5F6;
            a {
                display: flex;
                align-items: center;
                text-align: left;
                border-radius: 6px;
                height: 50px;
                font-size: 14px;
                padding: 0 6px;
                transition: all.4s;
                :hover {
                    background-color: #f6f6f6;
                }
                svg {
                    margin-right: 16px;
                    max-width: 22px;
                }
            }
        }
        .logout {
            display: flex;
            align-items: center;
            padding: 24px 0px 20px 6px;
            transition: all.4s;
            svg {
                margin-right: 20px;
            }
            :hover {
                color: red;
            }
        }
    }
    @media screen and (max-width:960px) {
        /* display: none; */
        .btn {
            display: none;
        }
        .dropdown {
            z-index: 100;
            position: fixed;
            top: 96px;
            left: 0;
            width: 100%;
            height: calc(100% - 124px);
            border-radius: 0;
            transition: none;
            &.open {transition: none;}
            ::after {display: none;}
            .nav {
                display: block;
            }
        }
    }
    @media screen and (max-width: 740px) {
        .dropdown {
            top: 64px;
            .header .headline {
                font-size: 20px;
            }
        }
    }
`;
export const CategoryDropdown = styled.div<any>`
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease 0s;

    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    /* height: 440px; */
    z-index: 100;
    background-color: #fff;
    padding: 28px 0 60px;

    ${({open})=> open && css`
        opacity: 1;
        visibility: visible;
        transition: all 0.4s ease 0s;
    `}
    .container {
        max-width: 1192px;
        margin: 0 auto;
        width: 100%;
        padding: 0 32px;
    }
    .headline {
        font-size: 24px;
        margin-bottom:  52px;
        font-weight: 700;
    }
    .list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        row-gap: 60px;
        column-gap: 60px;
        overflow: hidden;
        overflow-y: auto;
        max-height: 240px;
        padding-right: 2px;
        position: relative;
        z-index: 5;
        ::-webkit-scrollbar {
            width: 4px;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: #c4c4c4;
            border-radius: 4px;
        }
        ::-webkit-scrollbar-thumb:hover {
            background: #555;
        }


        .link {
            display: flex;
            align-items: center;
            border-radius: 8px;
            transition: all.5s;
            :nth-child(10n + 1) .hero {
                background-color: #d7c6f9;
            }
            :nth-child(10n + 2) .hero {
                background-color: #fff0d2;
            }
            :nth-child(10n + 3) .hero {
                background-color: #cae1fc;
            }
            :nth-child(10n + 4) .hero {
            background-color: #f8f5f1;
            }
            :nth-child(10n + 5) .hero {
            background-color: #e7f5d3;
            }
            :nth-child(10n + 6) .hero {
            background-color: #ffebeb;
            }
            :nth-child(10n + 7) .hero {
            background-color: #fcffde;
            }
            :nth-child(10n + 8) .hero {
            background-color: #d8e3f0;
            }
            :nth-child(10n + 9) .hero {
            background-color: #ffd8d8;
            }
            :nth-child(10n + 10) .hero {
            background-color: #e3ece1;
            }
            h4 {
                font-size: 14px;
                line-height: 1.4;
                margin-right: 8px;
            }
            .hero {
                position: relative;
                width: 40px;
                height: 40px;
                margin-right: 16px;
                background-color: gray;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                span {
                    margin: 10px;
                }
            }
            span {
                margin-left: auto;
                svg {
                height: 12px;
                width: auto;
                }
            }
        }
    }
    @media screen and (max-width: 1200px) {
        .list {
            row-gap: 40px;
            column-gap: 40px;
            .link h4{
                font-size: 12px;
            }
        }
    }
    @media screen and (max-width:960px) {
        .container {
            padding: 0 24px;
        }
        .list {
            grid-template-columns: repeat(3, 1fr);
            row-gap: 22px;
            column-gap: 22px;
        }
    }
    @media screen and (max-width:740px) {
        transition: none;
        height: calc(100vh - 124px);
        padding: 16px 0 0;
        .headline {
            font-size: 18px;
            margin-bottom: 20px;
            margin-top: 8px;
        }
        .container {
            padding: 0 16px;
        }
        .list {
            max-height: calc(100vh - 192px);
            padding-bottom: 88px;
            grid-template-columns: 1fr;
            row-gap: 16px;
            column-gap: 16px;
            .link h4{
                font-size: 12px;
            }
        }
    }
`;
export const DropdownsBackground = styled.div<any>`
    background-color: rgba(0, 0, 0, 0.66);
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 80;

    opacity: 0;
    visibility: hidden;
    transition: all 0.4s ease 0s;
    ${({shown})=> shown && css`
        opacity: 1;
        visibility: visible;
        transition: all 0.6s ease 0s;
        
    `}
    @media screen and (max-width:740px) {
        display: none;
    }
`;